<template>
    <v-container fluild>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />
        <v-row no-gutters class="mb-3">
            <v-col>
                <h2 :style="{ 'color': $store.getters.getColorPalette().accentCode }">{{ $store.getters.getTextMap().top_5_reasons }} {{ $store.getters.getTextMap().for }} {{ $store.getters.getTextMap().downtime }}</h2>
            </v-col>
            <v-col align="right">
                <v-btn @click="showReasonSummary=!showReasonSummary" class="mt-2" :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().accentCode" small text outlined >
                    {{ showReasonSummary?$store.getters.getTextMap().view_details:$store.getters.getTextMap().back }}
                </v-btn>
            </v-col>    
        </v-row>
        <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
        <v-row v-if="showReasonSummary" no-gutters class="d-flex justify-space-between">
            <v-col
                v-for="(item, index) in top5Reasons"
                :key="index"
                class="d-flex justify-center"
                cols=""
            >
                <v-card
                    flat
                    outlined
                    :dark="$store.getters.getColorPalette().isDark"
                    :color="$store.getters.getColorPalette().background2ColorCode"
                    class="mx-1 my-1"
                    elevation="3"
                    style="border-radius: 12px;"
                >
                    <v-card-title class="text-body-1 font-weight-bold" :style="{ color: $store.getters.getColorPalette().accentCode }">
                        {{ item.downtime_reason }}
                    </v-card-title>
                    <v-divider class="my-2"></v-divider>
                    <v-card-subtitle class="text-subtitle-1" :style="{ color: $store.getters.getColorPalette().textColor }">
                        <v-icon left color="primary">mdi-clock-outline</v-icon>
                        {{ item && item.total_downtime_duration ? ((Number(item.total_downtime_duration) / 3600).toFixed()) : 0 }} hrs 
                        ({{ item && item.total_downtime_duration ? ((Number(item.total_downtime_duration) / 60).toFixed()) : 0 }} Mins)
                    </v-card-subtitle>
                    <v-divider class="my-2"></v-divider>
                    <v-card-text>
                        <p class="text-body-2">
                            This reason accounted for 
                            <span :style="{ color: $store.getters.getColorPalette().textColor }">
                                {{ item && item.total_downtime_duration ? ((Number(item.total_downtime_duration) / 3600).toFixed()) : 0 }} hours
                            </span> of downtime.
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- <v-row v-if="showReasonSummary" no-gutters>
            <v-col
                v-for="(item, index) in top5Reasons"
                :key="index"
                class="d-flex justify-center"
                cols="12" sm="6" md="3" lg="3"
            >
                <v-card
                    flat
                    outlined
                    :dark="$store.getters.getColorPalette().isDark"
                    :color="$store.getters.getColorPalette().background2ColorCode"
                    class="mx-1 my-1"
                    elevation="3"
                    style="max-width: 400px; border-radius: 12px;"
                >
                    <v-card-title class="text-h6 font-weight-bold" :style="{ color: $store.getters.getColorPalette().accentCode }">
                        {{ item.downtime_reason }}
                    </v-card-title>
                    <v-divider class="my-2"></v-divider>
                    <v-card-subtitle class="text-subtitle-1" :style="{ color: $store.getters.getColorPalette().textColor }">
                        <v-icon left color="primary">mdi-clock-outline</v-icon>
                        {{ item && item.total_downtime_duration?((Number(item.total_downtime_duration)/3600).toFixed()):0 }} hrs ({{item && item.total_downtime_duration?((Number(item.total_downtime_duration)/60).toFixed()):0}} Mins)
                    </v-card-subtitle>
                    <v-divider class="my-2"></v-divider>
                    <v-card-text>
                        <p class="text-body-2">This reason accounted for <span :style="{ color: $store.getters.getColorPalette().textColor }">{{ item && item.total_downtime_duration?((Number(item.total_downtime_duration)/3600).toFixed()):0 }} hours</span> of downtime.</p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col>
                <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                <div :style="[{'display':reasonChartDisplay}]">
                    <div ref="vis2Horizontal"></div>
                </div>
                <div v-if="!(dbDataByCategory &&dbDataByCategory.length>0  && !loading)" :style="[{'padding':'10px','display':'flex','justify-content':'center','color':$store.getters.getColorPalette().accentCode}]">
                    <v-icon :dark="$store.getters.getColorPalette().isDark" class="mr-3">mdi-database-remove-outline</v-icon><h3>{{ $store.getters.getTextMap().no_data_available }}</h3>
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="!(top5Reasons && top5Reasons.length>0)">
            <v-col>
                <div :style="[{'padding':'10px','display':'flex','justify-content':'center','color':$store.getters.getColorPalette().accentCode}]">
                    <v-icon :dark="$store.getters.getColorPalette().isDark" class="mr-3">mdi-database-remove-outline</v-icon><h3>{{ $store.getters.getTextMap().no_data_available }}</h3>
                </div>
            </v-col>
        </v-row>
        <v-divider class="my-2" :dark="$store.getters.getColorPalette().isDark"></v-divider>
        <v-row class="my-3">
            <v-col>
                <h2 :style="{ 'color': $store.getters.getColorPalette().accentCode }">{{ $store.getters.getTextMap().top_5_categories }} {{ $store.getters.getTextMap().of }} {{ $store.getters.getTextMap().downtime }}</h2>
            </v-col>
            <v-col align="right">
                <v-btn  class="mt-2" @click="showCategorySummary=!showCategorySummary" :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().accentCode" small text outlined >
                    {{ showCategorySummary?$store.getters.getTextMap().view_details:$store.getters.getTextMap().back }}
                </v-btn>
            </v-col>  
        </v-row>
        <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
        <v-row v-if="showCategorySummary" no-gutters class="d-flex justify-space-between">
            <v-col
                v-for="(item, index) in top5Category"
                :key="index"
                class="d-flex justify-center"
                cols=""
            >
                <v-card
                    flat
                    outlined
                    :dark="$store.getters.getColorPalette().isDark"
                    :color="$store.getters.getColorPalette().background2ColorCode"
                    class="mx-1 my-1"
                    elevation="3"
                    style=" border-radius: 12px;"
                >
                    <v-card-title class="text-body-1 text-center font-weight-bold" :style="{ color: $store.getters.getColorPalette().accentCode }">
                        {{ item.category }}
                    </v-card-title>
                    <v-divider class="my-2"></v-divider>
                    <v-card-subtitle class="text-subtitle-1" :style="{ color: $store.getters.getColorPalette().textColor }">
                        <v-icon left color="primary">mdi-clock-outline</v-icon>
                        {{ item && item.total_downtime_duration ? ((Number(item.total_downtime_duration) / 3600).toFixed()) : 0 }} hrs 
                        ({{ item && item.total_downtime_duration ? ((Number(item.total_downtime_duration) / 60).toFixed()) : 0 }} Mins)
                    </v-card-subtitle>
                    <v-divider class="my-2"></v-divider>
                    <v-card-text>
                        <p class="text-body-2">
                            This reason accounted for 
                            <span :style="{ color: $store.getters.getColorPalette().textColor }">
                                {{ item && item.total_downtime_duration ? ((Number(item.total_downtime_duration) / 3600).toFixed()) : 0 }} hours
                            </span> of downtime.
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- <v-row v-if="showCategorySummary" no-gutters>
            <v-col
                v-for="(item, index) in top5Category"
                :key="index"
                class="d-flex justify-center"
                cols="12" sm="9" md="3"
            >
                <v-card
                    flat
                    outlined
                    :dark="$store.getters.getColorPalette().isDark"
                    :color="$store.getters.getColorPalette().background2ColorCode"
                    class="mx-1 my-1"
                    elevation="3"
                    style="max-width: 400px; border-radius: 12px;"
                >
                    <v-card-title class="text-h6 font-weight-bold" :style="{ color: $store.getters.getColorPalette().accentCode }">
                        {{ item.category }}
                    </v-card-title>
                    <v-divider class="my-2"></v-divider>
                    <v-card-subtitle class="text-subtitle-1" :style="{ color: $store.getters.getColorPalette().textColor }">
                        <v-icon left color="primary">mdi-clock-outline</v-icon>
                        {{ item && item.total_downtime_duration?((Number(item.total_downtime_duration)/3600).toFixed()):0 }} hrs ({{item && item.total_downtime_duration?((Number(item.total_downtime_duration)/60).toFixed()):0}} Mins)
                    </v-card-subtitle>
                    <v-divider class="my-2"></v-divider>
                    <v-card-text>
                        <p class="text-body-2">This reason accounted for <span :style="{ color: $store.getters.getColorPalette().textColor }">{{ item && item.total_downtime_duration?((Number(item.total_downtime_duration)/3600).toFixed()):0 }} hours</span> of downtime.</p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col>
                <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                <div :style="[{'display':chategoryChartDisplay}]">
                    <div ref="visHorizontal"></div>
                </div>
                <div v-if="!(dbDataByCategory &&dbDataByCategory.length>0  && !loading)" :style="[{'padding':'10px','display':'flex','justify-content':'center','color':$store.getters.getColorPalette().accentCode}]">
                    <v-icon :dark="$store.getters.getColorPalette().isDark" class="mr-3">mdi-database-remove-outline</v-icon><h3>{{ $store.getters.getTextMap().no_data_available }}</h3>
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="!(top5Category && top5Category.length>0)">
            <v-col>
                <div :style="[{'padding':'10px','display':'flex','justify-content':'center','color':$store.getters.getColorPalette().accentCode}]">
                    <v-icon :dark="$store.getters.getColorPalette().isDark" class="mr-3">mdi-database-remove-outline</v-icon><h3>{{ $store.getters.getTextMap().no_data_available }}</h3>
                </div>
            </v-col>
        </v-row>
        <v-divider class="my-2" :dark="$store.getters.getColorPalette().isDark"></v-divider>
        <v-row >
            <v-col :style="{'border-radius':'5px','border':'1px solid'+$store.getters.getColorPalette().panelBorderColorCode}">
                <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                <div v-else ref="vis"></div>
                <!-- <div v-if="!loading" :style="[{'display':chategoryChartDisplay}]">
                </div> -->
                <div v-if="!(dbDataByCategory &&dbDataByCategory.length>0  && !loading)" :style="[{'padding':'10px','display':'flex','justify-content':'center','color':$store.getters.getColorPalette().accentCode}]">
                    <v-icon :dark="$store.getters.getColorPalette().isDark" class="mr-3">mdi-database-remove-outline</v-icon><h3>{{ $store.getters.getTextMap().no_data_available }}</h3>
                </div>
            </v-col>
        <!-- </v-row>
        <v-row class="pt-1"> -->
            <v-col class="mx-1" :style="{'border-radius':'5px','border':'1px solid'+$store.getters.getColorPalette().panelBorderColorCode}">
                <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                <div v-else ref="vis2"></div>
                <!-- <div v-if="!loading" :style="[{'display':reasonChartDisplay}]">
                </div> -->
                <div v-if="!(dbDataByReason &&dbDataByReason.length>0 && !loading)"  :style="[{'padding':'10px','display':'flex','justify-content':'center','color':$store.getters.getColorPalette().accentCode}]">
                    <v-icon :dark="$store.getters.getColorPalette().isDark" class="mr-3">mdi-database-remove-outline</v-icon><h3>{{ $store.getters.getTextMap().no_data_available }}</h3>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import InfoAlert from '@/components/InfoAlert';
import axios from 'axios';
import Plotly from 'plotly.js';
// import moment from "moment";

export default {
    name: 'DowntimeReasonsPiechart',
    props: ["shift", "machines", "from_date", "to_date"],
    components: {
        InfoAlert
    },
    data() {
        return {
            showDismissibleAlert: false,
            loading: false,
            info: '',
            showReasonSummary:true,
            showCategorySummary:true,
            dbDataByCategory: [],
            dbDataByReason: [],
            top5Reasons: [],
            top5Category: [],
            chategoryChartDisplay:"none",
            reasonChartDisplay:"none",
            layout: {
                barcornerradius:"15",
                colorway: this.$store.getters.getColorPalette().colorTypesCodes,
                font: {
                    color: this.$store.getters.getColorPalette().accentCode
                },
                plot_bgcolor: this.$store.getters.getColorPalette().background2ColorCode,
                paper_bgcolor: this.$store.getters.getColorPalette().background2ColorCode,
                showlegend: true,
                automargin: true,
                legend: {
                    bgcolor: '#00000000',
                    font: {
                        size: 8,
                    },
                },
                autosize: true,
                xaxis: {
                    tickangle: -12,
                    zeroline: false,
                    showgrid: true,
                    showticklabels: true,
                    automargin: true,
                    tickpad: 5,
                    ticklen: 10,
                    title: {
                    text: 'Hours', // The label text
                    font: {
                        family: 'Arial, sans-serif', // Font family
                        size: 16, // Font size
                        color: this.$store.getters.getColorPalette().accentCode
                    }
                }
                },
                yaxis: {
                    showticklabels: true,
                    automargin: true,
                    tickpad: 5,
                    ticklen: 10,
                },
                uniformtext: {
                    mode: "hide",
                    minsize: 1
                }
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.chategoryChartDisplay = "none"
            this.reasonChartDisplay="none"
            if (this.from_date) {
                this.getDataByCategory();
                this.getDataByReason();
            }
        },
        createCategoryChart() {
            if (!(this.dbDataByCategory && this.dbDataByCategory.length > 0)) {
                this.chategoryChartDisplay = "none"
                return
            }
            let graphData = {};
            for (let i of this.dbDataByCategory) {
                graphData[i.category] = (Number(i.total_downtime_duration)/3600).toFixed();
            }
            let textInfo = 'value';
            this.layout['title'] = "Downtime By Categories";
            this.layout['colorway'] = Object.values(this.$store.getters.getColorPalette().colorTypesCodes);
            let data = null
            this.layout['annotations'] =null
            if (this.showCategorySummary) {
                this.layout['showlegend'] = false
                this.layout['annotations'] = [{
                        font: { size: 22 },
                        showarrow: false,
                        text: "Hours",
                        x: 0.5,
                        y: 0.5
                }];
                data = [{
                    values: Object.values(graphData),
                    labels: Object.keys(graphData),
                    type: 'pie',
                    text: "Hours",
                    textinfo: textInfo,
                    textposition: "outside",
                    opacity: 1,
                    hole: 0.7,
                    marker: {
                        line: {
                            color: this.$store.getters.getColorPalette().accentCode,
                            width: 1
                        },
                    }
                }];
            } else {
                 this.layout['barcornerradius'] = 15
                 this.layout['showlegend'] = false
                data = [{
                    x: Object.values(graphData),
                    y: Object.keys(graphData),
                    type: 'bar',
                    name:"Downtime (Hours)",
                    orientation: "h",
                    marker: {
                        line: {
                            color: this.$store.getters.getColorPalette().accentCode,
                            width: 1
                        },
                    }
                }];
            }
            if (this.$refs.vis && this.showCategorySummary) {
                    this.chategoryChartDisplay="initial"
                    Plotly.newPlot(this.$refs.vis, data, this.layout, { displaylogo: false });
            }
            if (this.$refs.visHorizontal && !this.showCategorySummary) {
                this.chategoryChartDisplay="initial"
                Plotly.newPlot(this.$refs.visHorizontal, data, this.layout, { displaylogo: false });
            }else{
                Plotly.purge(this.$refs.visHorizontal);
            }
        },
        createReasonChart() {
            if (!(this.dbDataByReason && this.dbDataByReason.length > 0)) {
                this.reasonChartDisplay = "none"
                return
            }
            let graphData = {};
            for (let i of this.dbDataByReason) {
                graphData[i.downtime_reason] = (Number(i.total_downtime_duration)/3600).toFixed();
            }
            let textInfo = 'value';
            this.layout['title'] = "Downtime By Reasons";
            this.layout['colorway'] = Object.values(this.$store.getters.getColorPalette().colorTypesCodes);
            let data = null
            this.layout['annotations'] =null
            if (this.showReasonSummary) {
                this.layout['showlegend'] = false
                this.layout['annotations'] = [{
                    font: { size: 22 },
                    showarrow: false,
                    text: "Hours",
                    x: 0.5,
                    y: 0.5
                }];
                data = [{
                    values: Object.values(graphData),
                    labels: Object.keys(graphData),
                    type: 'pie',
                    text: "Hours",
                    textinfo: textInfo,
                    textposition: "outside",
                    opacity: 1,
                    hole: 0.7,
                    marker: {
                        line: {
                            color: this.$store.getters.getColorPalette().accentCode,
                            width: 1
                        },
                    }
                }];
            } else {
                 this.layout['barcornerradius'] = 15
                 this.layout['showlegend'] = false
                data = [{
                    x: Object.values(graphData),
                    y: Object.keys(graphData),
                    type: 'bar',
                    name:"Downtime (Hours)",
                    orientation: "h",
                    marker: {
                        line: {
                            color: this.$store.getters.getColorPalette().accentCode,
                            width: 1
                        },
                    }
                }];
            }
            if (this.$refs.vis2 && this.showReasonSummary) {
                this.reasonChartDisplay="initial"
                Plotly.newPlot(this.$refs.vis2, data, this.layout, { displaylogo: false });
            }
            if (this.$refs.vis2Horizontal && !this.showReasonSummary) {
                this.reasonChartDisplay="initial"
                Plotly.newPlot(this.$refs.vis2Horizontal, data, this.layout, { displaylogo: false });
            }else{
                Plotly.purge(this.$refs.vis2Horizontal);
            }
        },
        createTopFiveReasonsData() {
            let temp = this.dbDataByReason.map(obj => ({
                ...obj
            }))
            this.top5Reasons = temp.sort((a, b) => b.total_downtime_duration - a.total_downtime_duration).slice(0, 5);
        },
        createTopFiveCategoryData() {
            let temp = this.dbDataByCategory.map(obj => ({
                ...obj
            }))
            this.top5Category = temp.sort((a, b) => b.total_downtime_duration - a.total_downtime_duration).slice(0, 5);
        },
        getDataByReason() {
            this.dbDataByReason = [];
            this.top5Reasons=[]
            this.loading = true;
            const payload = {
                machines: this.machines,
                shift: this.shift,
                from_date: this.from_date,
                to_date: this.to_date
            };
            axios.post(this.$store.state.api + "getTotalDowntimeGroupedByReasons", payload, { headers: { Authorization: 'Bearer ' + this.$store.state.jwt } })
                .then(response => {
                    if (response.data.status == "success") {
                        let dbData = response.data.data
                        dbData = dbData.sort(function (a, b) { return a.total_downtime_duration - b.total_downtime_duration })
                        this.dbDataByReason = dbData;
                        this.$nextTick(() => {
                            this.createReasonChart()
                            this.createTopFiveReasonsData()
                        });
                    } else {
                        this.info = response.data.msg;
                        this.showDismissibleAlert = true;
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.info = error;
                    this.showDismissibleAlert = true;
                    this.loading = false;
                });
        },
        getDataByCategory() {
            this.dbDataByCategory = [];
            this.top5Category=[]
            this.loading = true;
            const payload = {
                machines: this.machines,
                shift: this.shift,
                from_date: this.from_date,
                to_date: this.to_date
            };
            axios.post(this.$store.state.api + "getTotalDowntimeGroupedByCategories", payload, { headers: { Authorization: 'Bearer ' + this.$store.state.jwt } })
                .then(response => {
                    if (response.data.status == "success") {
                        let dbData = response.data.data
                        dbData = dbData.sort(function (a, b) { return a.total_downtime_duration - b.total_downtime_duration })
                        this.dbDataByCategory = dbData;
                        this.$nextTick(() => {
                            this.createCategoryChart()
                            this.createTopFiveCategoryData()
                        });
                    } else {
                        this.info = response.data.msg;
                        this.showDismissibleAlert = true;
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.info = error;
                    this.showDismissibleAlert = true;
                    this.loading = false;
                });
        }
    },
    watch: {
        // dbDataByCategory(newData, oldData) {
        //     if (newData !== oldData && newData.length > 0) {
        //         this.createCategoryChart();
        //         this.createTopFiveCategoryData();
        //     }
        // },
        // dbDataByCategory:{
        //     handler(){
        //         this.createCategoryChart();
        //         this.createTopFiveCategoryData();
        //     },
        //     deep:true
        // },
        // dbDataByReason:{
        //     handler(){
        //         this.createReasonChart();
        //         this.createTopFiveReasonsData();
        //     },
        //     deep:true
        // },
        // dbDataByReason(newData, oldData) {
        //     if (newData !== oldData && newData.length > 0) {
        //         this.createReasonChart();
        //         this.createTopFiveReasonsData();
        //     }
        // },
        shift() {
            this.init();
        },
        machines() {
            this.init();
        },
        from_date() {
            this.init();
        },
        to_date() {
            this.init();
        },
        showCategorySummary() {
            this.createCategoryChart()
        },
        showReasonSummary() {
            this.createReasonChart()
        }
    }
};
</script>
